import { sitePrefix } from "../../config";
import { whatsappRoutes } from "../../screens/Whatsapp/Constant";
export const DASHBOARD_SHORTCUT = {
  'appBar.groups.title': {
    title: 'appBar.groups.title',
    pages: [
      {
        title: 'dashboard.createGroup',
        link: '/react/Groups?NewGroup=true'
      },
      {
        title: 'appBar.groups.manageRecipients',
        link: '/react/Groups'
      },
      {
        title: 'appBar.groups.dynamicGroups',
        link: '/react/Groups/Dynamic'
        // link: '/Pulseem/DynamicGroups.aspx?fromreact=true'
      },
      {
        title: 'appBar.groups.search',
        link: '/Pulseem/ClientSearch.aspx'
      },
      // {
      //   title: 'dashboard.advanceSearch',
      //   link: '/Pulseem/ClientAdvancedSearch.aspx'
      // },
      {
        title: 'appBar.groups.fileUploads',
        link: '/react/Groups/FileUploads'
      },
      {
        title: 'master.fileDownload',
        link: '/react/groups/Download'
      }
    ]
  },
  'appBar.newsletter.title': {
    title: 'appBar.newsletter.title',
    pages: [
      {
        title: 'campaigns.create',
        link: '/react/Campaigns/Create'
      },
      {
        title: 'master.RadMenuItemResource9.Text',
        link: '/react/Campaigns'
      },
      {
        title: 'dashboard.createABTest',
        link: '/Pulseem/CampaignsByResults.aspx'
      },
      {
        title: 'master.linkAbTestingsResource1.Text',
        link: '/Pulseem/CampaignsAbTestings.aspx'
      },
      {
        title: 'master.RadMenuItemResource9a.Text',
        link: '/Pulseem/AutoSendPlans.aspx'
      },
      // {
      //   title: 'master.RadMenuItemResource10.Text',
      //   link: '/Pulseem/CampaignTemplates.aspx'
      // },
      {
        title: 'master.newslatterBasicEditor',
        link: '/Pulseem/CampaignEdit.aspx?NewsLetterType=Basic'
      },
      {
        title: 'master.campaignsArchive',
        link: '/react/Campaigns/Archive'
      }
    ]
  },
  'appBar.sms.title': {
    title: 'appBar.sms.title',
    pages: [
      {
        title: 'common.CreateSMS',
        link: '/react/sms/create'
      },
      {
        title: 'dashboard.smsManagement',
        link: '/react/SMSCampaigns'
      },
      {
        title: 'master.chatbotSMS',
        link: '/SMSSmartResponses'
      },
      {
        title: 'master.linkSMSResponsesReport.Text',
        link: '/react/reports/Inbound'
      }
    ]
  },
  'appBar.whatsapp.title': {
    title: 'appBar.whatsapp.title',
    pages: [
      {
        title: 'whatsapp.NewWhatsappCampaign',
        link: whatsappRoutes.CREATE_TEMPLATE
      },
      {
        title: 'whatsapp.SendWhatsappCampaign',
        link: whatsappRoutes.CREATE_CAMPAIGN_PAGE1
      },
      {
        title: 'whatsapp.ManageWhatsappTemplate',
        link: whatsappRoutes.TEMPLATE_MANAGEMENT
      },
      {
        title: 'whatsapp.ManageWhatsappCampaign',
        link: whatsappRoutes.CAMPAIGN_MANAGEMENT
      },
      {
        title: 'whatsapp.ChatWhatsapp',
        link: whatsappRoutes.CHAT
      }
    ]
  },
  'appBar.mms.title': {
    title: "appBar.mms.title",
    pages: [
      {
        title: 'common.CreateMMS',
        link: '/CreateMmsCampaign'
      },
      {
        title: 'dashboard.mmsManagement',
        link: '/react/MmsCampaigns'
      }
    ],
  },
  'appBar.landingPages.title': {
    title: "appBar.landingPages.title",
    pages: [
      {
        title: 'landingPages.CreateNewResource.Text',
        link: `/${sitePrefix}LandingPages/Create`
      },
      {
        title: 'landingPages.logPageHeaderResource1.Text',
        link: `/${sitePrefix}EditRegistrationPage`
      }
    ]
  },
  'appBar.reports.title': {
    title: 'appBar.reports.title',
    pages: [
      {
        title: 'master.RadMenuItemResource13.Text',
        link: '/react/reports/NewsletterReports'
      },
      {
        title: 'master.RadMenuItemResource24.Text',
        link: '/react/reports/SMSMainReport'
      },
      // {
      //   title: 'master.MmsMainReport.Text',
      //   link: '/react/reports/MMSMainReport'
      // },
      // {
      //   title: 'master.AbTestsReport.Text',
      //   link: '/Pulseem/AbTestsReport.aspx'
      // },
      {
        title: 'master.RadMenuItemResource15.Text',
        link: `${sitePrefix}AccountReport`
      },
      {
        title: 'master.RadMenuItemResource18.Text',
        link: '/react/Reports/Recipient'
      },
      {
        title: 'master.RadMenuItemResource30.Text',
        link: `${sitePrefix}EmailAutoReports`
      },
      {
        title: 'dashboard.unsubscribeReports',
        link: `${sitePrefix}RemovedStats`
      },
      {
        title: 'master.DirectReportsResource1.Text',
        link: '/react/Reports/DirectSendReport?t=1'
      },
      {
        title: 'master.DirectSmsReport.Text',
        link: '/react/Reports/DirectSendReport?t=0'
      },
      {
        title: 'dashboard.openedClickedReport',
        link: `${sitePrefix}EmailCampaignStatistics`
      }

    ]
  },
  'appBar.automation.title': {
    title: 'appBar.automation.title',
    pages: [
      {
        title: 'automations.createResource.Text',
        link: `${sitePrefix}CreateAutomations`
      },
      {
        title: 'dashboard.automationManagement',
        link: `${sitePrefix}Automations`
      }
    ]
  }
}